"use strict";

function readPageData(id) {
    const el = document.getElementById(id);
    if(!el)
        return {};

    try {
        const parsed = JSON.parse(el.textContent || el.innerText || '{}');
        if(parsed && typeof parsed === 'object')
            return parsed;
    } catch(e) {
        return {};
    }

    return {};
}

module.exports = readPageData;



// WEBPACK FOOTER //
// ./resources/assets/js/page-data.js